import Model, { attr } from '@ember-data/model';

export default class GroupRecord extends Model {
	@attr('string') name!: string;
	@attr('string') description!: string | null;
	@attr('string') color!: string;
}
